const footerLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Book Now', href: '#booking' },
  { label: 'Payment', href: '#payment' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-gray-900">
      {/* CTA Banner */}
      <div className="bg-gradient-to-r from-gray-900 via-[#1a1a1a] to-gray-900 border-b border-gray-800 py-10">
        <div className="max-w-5xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-gray-500 text-xs tracking-[0.2em] uppercase mb-1">Limited Prom Dates Available</p>
            <h3 className="font-display silver-gradient-text text-3xl font-semibold">Book Early. Arrive in Style.</h3>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:2677731129"
              className="btn-silver rounded-full px-8 py-3 text-xs tracking-[0.2em] uppercase cursor-pointer whitespace-nowrap text-center"
            >
              Call (267) 773-1129
            </a>
            <a
              href="#booking"
              onClick={(e) => { e.preventDefault(); handleScroll('#booking'); }}
              className="btn-outline-silver rounded-full px-8 py-3 text-xs tracking-[0.2em] uppercase cursor-pointer whitespace-nowrap text-center"
            >
              Book Online
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-5xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <span className="font-display silver-gradient-text text-xl font-semibold tracking-[0.2em] uppercase">Luxury Prom</span>
              <br />
              <span className="text-gray-600 text-[9px] tracking-[0.35em] uppercase">Chauffeur Experience</span>
            </div>
            <p className="text-gray-500 text-xs leading-relaxed mb-4">
              Philadelphia's premier luxury prom chauffeur service. Featuring the 2026 BMW 740i and 530i with professional chauffeur included.
            </p>
            <p className="text-gray-600 text-xs italic font-display">"Arrive in Style. Leave an Impression."</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-gray-400 text-xs tracking-[0.2em] uppercase mb-5 font-medium">Quick Links</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleScroll(link.href); }}
                    className="text-gray-500 hover:text-gray-300 text-xs tracking-wide transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-gray-400 text-xs tracking-[0.2em] uppercase mb-5 font-medium">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-gray-500 text-sm"></i>
                </div>
                <a href="tel:2677731129" className="text-gray-400 text-xs hover:text-gray-300 cursor-pointer">(267) 773-1129</a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-map-pin-line text-gray-500 text-sm"></i>
                </div>
                <span className="text-gray-400 text-xs">Philadelphia, PA</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-car-line text-gray-500 text-sm"></i>
                </div>
                <span className="text-gray-400 text-xs leading-relaxed">2026 BMW 740i &amp; 530i<br />Chauffeur Always Included</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="section-divider mb-6"></div>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-700 text-xs">
            &copy; {new Date().getFullYear()} Luxury Prom Chauffeur Experience. Philadelphia, PA. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-lock-line text-gray-700 text-xs"></i>
            </div>
            <span className="text-gray-700 text-xs">Secure Stripe Payments</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
